import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Snackbar, Alert } from '@mui/material';

import { createShowErrorAction, createShowInfoAction, createShowSuccessAction, createShowWarningAction } from '../../actions/notifications';
import { selectNotificationError, selectNotificationInfo, selectNotificationSuccess, selectNotificationWarning } from '../../reducers/notifications';

const setErrorAction = createShowErrorAction();
const setInfoAction = createShowInfoAction();
const setSuccessAction = createShowSuccessAction();
const setWarningAction = createShowWarningAction();

const handleClose = (reason: string, dispatch: any, setAction: any) => {
  if (reason === 'clickaway') {
    return;
  }

  dispatch(setAction(null));
};

const autoHideDuration = 6000;
const variant = 'filled';

export default () => {
  const error = useSelector(selectNotificationError);
  const info = useSelector(selectNotificationInfo);
  const success = useSelector(selectNotificationSuccess);
  const warning = useSelector(selectNotificationWarning);
  const dispatch = useDispatch();

  const handleErrorClose = (event?: React.SyntheticEvent, reason?: string) => handleClose(reason, dispatch, setErrorAction);
  const handleInfoClose = (event?: React.SyntheticEvent, reason?: string) => handleClose(reason, dispatch, setInfoAction);
  const handleSuccessClose = (event?: React.SyntheticEvent, reason?: string) => handleClose(reason, dispatch, setSuccessAction);
  const handleWarningClose = (event?: React.SyntheticEvent, reason?: string) => handleClose(reason, dispatch, setWarningAction);

  return (
    <div>
      <Snackbar open={error && error !== ''} autoHideDuration={autoHideDuration} onClose={handleErrorClose}>
        <Alert elevation={6} onClose={handleErrorClose} severity='error' variant={variant}>{error}</Alert>
      </Snackbar>
      <Snackbar open={info && info !== ''} autoHideDuration={autoHideDuration} onClose={handleInfoClose}>
        <Alert elevation={6} onClose={handleInfoClose} severity='info' variant={variant}>{info}</Alert>
      </Snackbar>
      <Snackbar open={success && success !== ''} autoHideDuration={autoHideDuration} onClose={handleSuccessClose}>
        <Alert elevation={6} onClose={handleSuccessClose} severity='success' variant={variant}>{success}</Alert>
      </Snackbar>
      <Snackbar open={warning && warning !== ''} autoHideDuration={autoHideDuration} onClose={handleWarningClose}>
        <Alert elevation={6} onClose={handleWarningClose} severity='warning' variant={variant}>{warning}</Alert>
      </Snackbar>
    </div>
  );
}

